import { render, staticRenderFns } from "./systemNews.vue?vue&type=template&id=10efd2d6&scoped=true"
import script from "./systemNews.vue?vue&type=script&lang=js"
export * from "./systemNews.vue?vue&type=script&lang=js"
import style0 from "./systemNews.vue?vue&type=style&index=0&id=10efd2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10efd2d6",
  null
  
)

export default component.exports